import { ImageOrSet, IndexKey, PartKey, Uuid } from '../../models/Base';
import {
  ConcreteGameJson,
  GameCollectionJson,
  GameJson,
  GameStatisticsJson,
  GameType,
} from '../../models/GameStore';
import { ModifiedPick, RequiredPick } from '../../models/Utils';
import { CursorData, CursorParams, Scope } from '../utils';

import restClient, { RestRequestOptions, RestResponse } from '.';

interface GameCollectionsData {
  gameCollections: GameCollectionJson[];
}
export const getGameCollections = (
  params: {
    gameCollectionIds?: Uuid[];
    classroomId?: Uuid;
  } & CursorParams = {},
  options?: RestRequestOptions,
): Promise<RestResponse<GameCollectionsData & CursorData>> => {
  return restClient.get('/game-collections', params, options);
};

interface GameCollectionData {
  gameCollection: GameCollectionJson;
}

export const createGameCollection = (
  body: { classroomId: string } & RequiredPick<GameCollectionJson, 'parts'>,
  options?: RestRequestOptions,
): Promise<RestResponse<GameCollectionData>> => {
  return restClient.post(`/game-collections`, body, options);
};

interface GameData {
  game: GameJson;
}
export const getGame = (
  path: { gameCollectionId: Uuid; gameId: Uuid },
  params: { hash: string } & Scope,
  options?: RestRequestOptions,
): Promise<RestResponse<GameData>> => {
  return restClient.get(
    `/game-collections/${path.gameCollectionId}/games/${path.gameId}`,
    params,
    options,
  );
};

interface GamesData {
  gameCollection: GameCollectionJson;
  games: Record<PartKey, Record<IndexKey, ConcreteGameJson<GameType>>>;
}

type CreateGameParams = {
  assistedGame?: 'before' | 'after' | 'off';
  background?: ImageOrSet;
  isForChallenge?: boolean;
} & ModifiedPick<
  ConcreteGameJson<GameType>,
  'i18nGameData' | 'gameType',
  'timeLimit' | 'scenario'
>;

export type CreateGamesInGameCollectionBody = {
  games: Partial<Record<PartKey, Partial<Record<IndexKey, CreateGameParams>>>>;
  profanityFilterMode?: string;
};

export const createGamesInGameCollection = (
  path: { gameCollectionId: string },
  body: CreateGamesInGameCollectionBody,
  options?: RestRequestOptions,
): Promise<RestResponse<GamesData>> => {
  return restClient.post(
    `/game-collections/${path.gameCollectionId}/games`,
    body,
    options,
  );
};

interface GameStatisticsData {
  gameStatistics: GameStatisticsJson;
}
export const getGameStatistics = (
  path: { gameCollectionId: Uuid; gameId: Uuid },
  params: Scope = {},
  options?: RestRequestOptions,
): Promise<RestResponse<GameStatisticsData>> => {
  return restClient.get(
    `/game-collections/${path.gameCollectionId}/games/${path.gameId}/statistics`,
    params,
    options,
  );
};
